module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution1.1fde1009.png";